







import LocationSearchControl from '@/components/common/LocationSearchControl.vue';
import {SearchResultItem} from '@/model/api/search';
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({components: {LocationSearchControl}, props: ['data-nette-rules', 'name', 'value', 'placeholder']})
export default class LocationInput extends Vue {
    /**
     * Passed JSON encoded default value
     */
    @Prop({type: String, required: true})
    public readonly value: string;

    private currentValue: SearchResultItem | null = null;

    protected created(): void {
        this.currentValue = JSON.parse(this.value);
    }
}
